import RsaGestionePresenze from "../";

const routes = [{ name: "RsaGestionePresenzeList", path: "/rsagestionepresenzelist", component: RsaGestionePresenze.RsaGestionePresenzeListPage, meta: { title: " Gestione Presenze" } }];
export default routes;
